interface FlagIconProps {
  id: number;
  name: string;
  color: string;
}

export const FlagIcon: React.FC<FlagIconProps> = (props) => {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ padding: '0px 5px' }}
    >
      <path
        d="M21 9.0359C23.6667 10.5755 23.6667 14.4245 21 15.9641L6.74999 24.1913C4.08333 25.7309 0.749999 23.8064 0.749999 20.7272L0.75 4.27275C0.75 1.19355 4.08333 -0.730944 6.75 0.808657L21 9.0359Z"
        fill={props.color}
      />
      <text
        x="0"
        y="18"
        fill={props.id === 1 ? '#2C2D3E' : '#FFFFFF'}
        fontFamily="OpenDyslexic"
        fontStyle="italic"
        fontWeight="700"
        fontSize="12px"
      >
        {props.name[0]}
      </text>
    </svg>
  );
};
